import { newToast } from '../components';
import { OrderSamplesRequest, SysI_CodBarrasImpresoras } from '../types/types.barcodes';
import useApi from '../utils/axios-pettitions';
import { CustomFilters } from '../types/types.system';

export const useApiBarcodes = () => {
  const { runApi } = useApi();

  const getLabelsByFilters = async (filters: CustomFilters[]) => {
    return runApi('Barcode/GetLabelsByFilters', 'POST', null, filters).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {        
        return res.data;
      }
    });
  };

  const getPrinters = () => {
    return runApi('Barcode/GetPrinters', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        return res.data as SysI_CodBarrasImpresoras[];
      }
    });
  };

  const PrintBarcodeLabels = ({ printer, IdOrden, LstIdsEstudios }: { printer: SysI_CodBarrasImpresoras; IdOrden: number; LstIdsEstudios?: number[] }) => {
    return runApi('Barcode/Print', 'POST', null, { IdPrinter: printer.Cbp_Id, IdOrden, LstIdsEstudios }).then((res) => {
      if (res.internalCode === 101) {
        newToast('SUCCESS', `Etiquetas enviadas a la impresora '${printer?.Cbp_Nombre}'`, 5);
        return;
      }      
    });
  };

  const PrintBarcodeLabelsMasive = (data: OrderSamplesRequest[], printer: SysI_CodBarrasImpresoras) => {    
    return runApi('Barcode/PrintMasive', 'POST', null, data).then((res) => {
      if (res.internalCode === 101) {
        newToast('SUCCESS', `Etiquetas enviadas a la impresora '${printer?.Cbp_Nombre}'`, 5);
        return;
      }      
    });
  };

  const getPrintsBarcodes = async () => {
    return runApi('Barcode/GetAllPrinters', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const addPrintBarcode = async (printer: SysI_CodBarrasImpresoras) => {
    return runApi('Barcode/CreatePrinter', 'POST', null, printer).then((res) => {
      if (res.internalCode === 105) {
        newToast('SUCCESS', 'Impresora agregada correctamente', 5);
        return res.data;
      } else {
        throw new Error('Error al agregar impresora');
      }
    });
  };

  const editPrintBarcode = async (printer: SysI_CodBarrasImpresoras) => {
    console.log('printer', printer);
    return runApi('Barcode/EditPrinter', 'POST', null, printer).then((res) => {
      if (res.internalCode === 105) {
        newToast('SUCCESS', 'Impresora editada correctamente', 5);
        return res.data;
      } else {
        
        throw new Error('Error al editar impresora');
      }
    });
  };

  const deletePrintBarcode = async (id: number) => {
    return runApi('Barcode/DeletePrinter', 'POST', { idPrinter: id }, null).then((res) => {
      if (res.internalCode === 108) {
        newToast('SUCCESS', 'Impresora eliminada correctamente', 5);
        return res.data;
      } else {
        newToast('ERROR', res.messageDetails || res.message, 5);
        throw new Error('Error al eliminar impresora');
      }
    });
  };

  return { getLabelsByFilters, getPrinters, PrintBarcodeLabels, getPrintsBarcodes, addPrintBarcode, editPrintBarcode, deletePrintBarcode, PrintBarcodeLabelsMasive };
};
